import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button } from 'antd';
import { TrainingProjectSessionModel } from '../../models';
import ReactJson from 'react-json-view';

interface Props {
    session?: TrainingProjectSessionModel;
    visible: boolean;
    onClose: () => void;
}

const TrainingProjectSessionMetricsModal: React.FC<Props> = ({ session, visible, onClose }) => {
    return (
        <Modal
            className="alpha-portal-dialog"
            bodyStyle={{ maxHeight: 'calc(100vh - 310px)' }}
            width={800}
            visible={visible}
            title="Metrics"
            onCancel={onClose}
            maskClosable={false}
            centered
            footer={[
                <Button key="back" type="primary" onClick={onClose}>
                    Close
                </Button>
            ]}
        >
            <ReactJson src={session?.metrics ?? {}} displayDataTypes={false} name={false} enableClipboard={false} />
        </Modal>
    );
};

export default observer(TrainingProjectSessionMetricsModal);
